import React from 'react';
import { Outlet } from 'react-router-dom';
import WealthOSSidebar from '../components/WealthOS/WealthOSSidebar.js';

const WealthOSLayout: React.FC = () => {
  return (
    <div className="h-screen bg-slate-900 flex overflow-hidden">
      <WealthOSSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
};

export default WealthOSLayout;
